module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-48.c77c11f9.jpg";